import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { TeamMember } from "@/lib/types";
interface TeamCardProps {
  member: TeamMember;
  index: number;
}

// Presentational team card — used both as the active (top-left) card and as
// the cards collected in the bottom-right stack. Neo-brutalist frame matches
// the AppButton aesthetic used across the site.
const TeamCard = t0 => {
  const $ = _c(20);
  const {
    member,
    index
  } = t0;
  let t1;
  if ($[0] !== member.image || $[1] !== member.name) {
    t1 = <Image src={member.image} alt={member.name} fill={true} sizes="(max-width: 1024px) 90vw, 320px" className="object-cover transition-transform duration-700 ease-out group-hover:scale-105" />;
    $[0] = member.image;
    $[1] = member.name;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="absolute inset-0 bg-linear-to-t from-black/85 via-black/15 to-transparent" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = index + 1;
  let t4;
  if ($[4] !== t3) {
    t4 = <span className="absolute top-4 left-4 text-xs font-black tracking-[0.2em] text-white/90">0{t3}</span>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== member.accentColor) {
    t5 = <span className="absolute top-4 right-4 h-3 w-3 rounded-full ring-2 ring-white/40" style={{
      backgroundColor: member.accentColor
    }} />;
    $[6] = member.accentColor;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== member.name) {
    t6 = <h3 className="text-xl font-black uppercase leading-none tracking-tight text-white">{member.name}</h3>;
    $[8] = member.name;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== member.designation) {
    t7 = <p className="mt-1 text-xs font-semibold uppercase tracking-[0.2em] text-primary">{member.designation}</p>;
    $[10] = member.designation;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <div className="absolute bottom-0 left-0 w-full p-5">{t6}{t7}</div>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t1 || $[16] !== t4 || $[17] !== t5 || $[18] !== t8) {
    t9 = <div className="group relative w-full h-full overflow-hidden rounded-2xl border-2 border-black bg-neutral-200 shadow-[8px_8px_0_0_rgba(0,0,0,1)]">{t1}{t2}{t4}{t5}{t8}</div>;
    $[15] = t1;
    $[16] = t4;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
export default TeamCard;